import React from 'react'
import Product from '../components/Header/Product'
export default function ProductPage() {
  return (
    <>
    <Product/>
    </>
  )
}
